import type { StepConfig } from '@/components/CreateCampaignDialog/createCampaignType'
import { AllocateFundsStep } from '@/components/CreateCampaignDialog/steps/AllocateFundsStep/AllocateFundsStep'
import { CampaignAssetsStep } from '@/components/CreateCampaignDialog/steps/CampaignAssetsStep/CampaignAssetsStep'
import { CampaignInfoStep } from '@/components/CreateCampaignDialog/steps/CampaignInfoStep/CampaignInfoStep'
import { GeneralInfoStep } from '@/components/CreateCampaignDialog/steps/GeneralInfoStep/GeneralInfoStep'
import { InfluencersRequirements } from '@/components/CreateCampaignDialog/steps/InfluencersRequirements/InfluencersRequirements'
import { UploadImageStep } from '@/components/CreateCampaignDialog/steps/UploadImageStep/UploadImageStep'

export const campaignSteps: StepConfig[] = [
  {
    id: 1,
    title: 'Campaign Info',
    component: CampaignInfoStep,
  },
  {
    id: 2,
    title: 'General Info',
    component: GeneralInfoStep,
  },
  {
    id: 3,
    title: 'Influencers Requirements',
    component: InfluencersRequirements,
  },
  {
    id: 4,
    title: 'Upload Image',
    component: UploadImageStep,
  },
  {
    id: 5,
    title: 'Campaign Assets',
    component: CampaignAssetsStep,
  },
  {
    id: 6,
    title: 'Allocate funds',
    component: AllocateFundsStep,
  },
]
